import { useMemo } from "react";

import { SwitcherOption } from "../ShareTypeSwitcher";

export const switcherToDataIndexMap: Record<SwitcherOption, string> = {
    [SwitcherOption.Spend]: "spend",
    [SwitcherOption.Impressions]: "impressions",
    [SwitcherOption.Visits]: "visits",
};

export interface IFieldNames {
    dataField: "impressions" | "spend" | "visits" | "impressionsShare" | "spendShare" | "visitsShare";
    changeField: "impressionsChange" | "spendChange" | "visitsChange";
}

export const getFieldsForSwitcherOption = (
    selectedSwitcherOption: SwitcherOption,
    useShareSuffix = false,
): IFieldNames => {
    const dataKey = switcherToDataIndexMap[selectedSwitcherOption];
    const dataField = useShareSuffix ? `${dataKey}Share` : dataKey;
    const changeField = `${dataKey}Change`;

    return {
        dataField: dataField as IFieldNames["dataField"],
        changeField: changeField as IFieldNames["changeField"],
    };
};

export const useSwitcherLogic = (selectedSwitcherOption: SwitcherOption, useShareSuffix = false) => {
    const switcherData = useMemo(() => {
        const dataKey = switcherToDataIndexMap[selectedSwitcherOption];
        const dataField = useShareSuffix ? `${dataKey}Share` : dataKey;
        const changeField = `${dataKey}Change`;
        const isSpend = dataKey === "spend";

        return {
            dataField: dataField as IFieldNames["dataField"],
            changeField: changeField as IFieldNames["changeField"],
            isSpend,
            switcherKey: dataKey,
        };
    }, [selectedSwitcherOption, useShareSuffix]);

    return switcherData;
};
